//import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useFetch } from '../../hooks/useFetch'
import FilterDrawer from '../organisms/FilterDrawer'
import { BASE_URL } from '../../utils/constants'

const VocabFetcher = ({
  handleDrawer,
  isOpen,
  selectedYear,
  setSelectedYear
}) => {
  const {
    //loading: reliLoading,
    data: reliVocab
    // error: reliError
  } = useFetch(`${BASE_URL}/omiddata/getvocab/religion`)
  const {
    //loading: reliLoadingFa,
    data: reliVocabFa
    // error: reliError
  } = useFetch(`${BASE_URL}/fa/omiddata/getvocab/religion`)
  const {
    // loading: genderLoading,
    data: genderVocab
    // error: genderError
  } = useFetch(`${BASE_URL}/omiddata/getvocab/gender`)
  const {
    //loading: genderLoadingFa,
    data: genderVocabFa
    // error: genderError
  } = useFetch(`${BASE_URL}/fa/omiddata/getvocab/gender`)
  const {
    //loading: occuLoading,
    data: occuVocab
    // error: genderError
  } = useFetch(`${BASE_URL}/omiddata/getvocab/occupation`)
  const {
    //loading: occuLoadingFa,
    data: occuVocabFa
    // error: genderError
  } = useFetch(`${BASE_URL}/fa/omiddata/getvocab/occupation`)
  const {
    //loading: eduLoading,
    data: eduVocab
    // error: genderError
  } = useFetch(`${BASE_URL}/omiddata/getvocab/education`)
  const {
    //loading: eduLoadingFa,
    data: eduVocabFa
    //error: genderError
  } = useFetch(`${BASE_URL}/fa/omiddata/getvocab/education`)
  const {
    //loading: killingLoading,
    data: threatVocab
    //error: genderError
  } = useFetch(`${BASE_URL}/omiddata/getvocab/nonfatalviolation`)
  const {
    //loading: killingLoading,
    data: threatVocabFa
    //error: genderError
  } = useFetch(`${BASE_URL}/fa/omiddata/getvocab/nonfatalviolation`)
  const {
    //loading: killingLoading,
    data: killingVocab
    //error: genderError
  } = useFetch(`${BASE_URL}/omiddata/getvocab/violation?parent=21`)
  const {
    //loading: killingLoadingFa,
    data: killingVocabFa
    //error: genderError
  } = useFetch(`${BASE_URL}/fa/omiddata/getvocab/violation?parent=21`)
  // const [loading, setLoading] = useState(true)
  // const [error, setError] = useState('')
  // const [vocabData, setVocabData] = useState([])

  // useEffect(() => {
  //   setLoading(true)
  //   Promise.all([
  //     fetch(`https://staging.bfiran.org/omiddata/getvocab/religion`),
  //     fetch(`https://staging.bfiran.org/fa/omiddata/getvocab/religion`),
  //     fetch(`https://staging.bfiran.org/omiddata/getvocab/gender`),
  //     fetch(`https://staging.bfiran.org/fa/omiddata/getvocab/gender`),
  //     fetch(`https://staging.bfiran.org/omiddata/getvocab/occupation`),
  //     fetch(`https://staging.bfiran.org/fa/omiddata/getvocab/occupation`),
  //     fetch(`https://staging.bfiran.org/omiddata/getvocab/education`),
  //     fetch(`https://staging.bfiran.org/fa/omiddata/getvocab/education`),
  //     fetch(`https://staging.bfiran.org/omiddata/getvocab/nonfatalviolation`),
  //     fetch(
  //       `https://staging.bfiran.org/fa/omiddata/getvocab/nonfatalviolation`
  //     ),
  //     fetch(`https://staging.bfiran.org/omiddata/getvocab/violation?parent=21`),
  //     fetch(
  //       `https://staging.bfiran.org/fa/omiddata/getvocab/violation?parent=21`
  //     )
  //   ])
  //     .then(async (res) => {
  //       const allData = await Promise.all(
  //         res.map(async (data) => await data.json())
  //       )
  //       console.log('all', allData)
  //       setVocabData(allData)
  //       setError(null)
  //       setLoading(false)
  //     })
  //     .catch((e) => {
  //       console.warn(e.message)
  //       setError('Error fetching data. Try again.')
  //       setLoading(false)
  //     })
  // }, [])

  //if (killingLoadingFa) return <p>Loading...</p> //last one
  // if (error) return <p>{error}</p>

  return (
    <FilterDrawer
      handleDrawer={handleDrawer}
      isOpen={isOpen}
      selectedYear={selectedYear}
      setSelectedYear={setSelectedYear}
      reliVocab={reliVocab}
      reliVocabFa={reliVocabFa}
      genderVocab={genderVocab}
      genderVocabFa={genderVocabFa}
      occuVocab={occuVocab}
      occuVocabFa={occuVocabFa}
      eduVocab={eduVocab}
      eduVocabFa={eduVocabFa}
      threatVocab={threatVocab}
      threatVocabFa={threatVocabFa}
      killingVocab={killingVocab}
      killingVocabFa={killingVocabFa}
    />
  )
}

export default VocabFetcher

VocabFetcher.propTypes = {
  handleDrawer: PropTypes.func,
  isOpen: PropTypes.bool,
  selectedYear: PropTypes.array,
  setSelectedYear: PropTypes.func
}
